import { useState } from 'react';
import '../App.css';
import '../Tileandpopout.css';

const ProjectTile = ({img, dir, text}) => {

  const [loaded, setLoaded] = useState(false)

  const postLoad = ( event ) => {
    event.target.classList.add('loaded')
    setLoaded(true)
  }

  return(
      <div className={`tile ${loaded ? '' : 'loadinganimation'}`}>
        <img src={`userdata/work/${dir}/${img}`} className={`worktile-img lazyloader`}  loading='lazy' onLoad={(e) => postLoad(e)} alt='project tile' />
        <p className='tile-text'>{text}</p>
      </div>
  )

}

export default ProjectTile;